<div class="mobile-wrapper">
    <slot />
</div>

<style lang="scss">

    .mobile-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: var(--vh, 100vh);
        display: flex;
        flex-direction: column;
    }

</style>
